export const onlyNumbers = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 8) return;
  e.preventDefault();
};
export const onlyLetters = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  if ((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122))
    return;
  e.preventDefault();
};
export const onlyLettersWithSpace = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  if (
    (keyCode >= 65 && keyCode <= 90) ||
    (keyCode >= 97 && keyCode <= 122) ||
    keyCode === 32
  ) {
    return;
  }

  e.preventDefault();
};

export const onlyLettersNumbersAndDot = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  if (
    (keyCode >= 48 && keyCode <= 57) ||
    (keyCode >= 65 && keyCode <= 90) ||
    (keyCode >= 97 && keyCode <= 122) ||
    keyCode === 46
  ) {
    return;
  }
  e.preventDefault();
};

export const onlyDecimalNumbers = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  const value = e.target.value;

  //don't allow one decimal point as the first input
  if (!value && keyCode === 46) {
    e.preventDefault();
    return;
  }

  //don't allow more that one decimal point
  if (value && value.includes(".") && keyCode === 46) {
    e.preventDefault();
    return;
  }

  //don't allow more then two numbers after the decimal point
  const numbersBeforeAndAfterDecimalPoint = value.split(".").filter(Boolean);
  if (
    numbersBeforeAndAfterDecimalPoint &&
    numbersBeforeAndAfterDecimalPoint.length &&
    numbersBeforeAndAfterDecimalPoint[1] &&
    numbersBeforeAndAfterDecimalPoint[1].length === 2 &&
    value.length - 3 !== e.target.selectionStart
  ) {
    e.preventDefault();
    return;
  }
  //valid input
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 8 || keyCode === 46) {
    return;
  } else {
    e.preventDefault();
  }
};

export const onlyNumbersAndDot = e => {
  const keyCode = e.keyCode ? e.keyCode : e.which;
  // var regexp = /^\d+\.\d{0,2}$/;
  if ((keyCode >= 48 && keyCode <= 57) || keyCode === 8 || keyCode === 46)
    return;
  e.preventDefault();
};
